import React, { useEffect, useState } from "react";
import { env as environment } from "./actions/environment";

const IframePage = () => {
  const [ifmpage, setIfmpage] = useState({
    page: false,
    redirectLink: "",
    opacity: true,
  });

  useEffect(() => {
    getiframeLink();
  }, []);

  // console.log(parsed, "Parsed place");
  // console.log(parsed.trackid);

  // if(ifmpage.opacity) {

  // }
  // function isMobileOrTablet() {
  //   return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  //     navigator.userAgent
  //   );
  // }
  function getiframeLink() {
    console.log("getiframeLink Hit ===================");

    // window.location.replace(res.data.verificationlink);
    setIfmpage((prev) => ({
      ...prev,
      page: true,
      redirectLink: environment.frontendurl + window.location.search,
    }));
    setTimeout(function () {
      setIfmpage((prev) => ({ ...prev, opacity: false }));
    }, 500);
  }

  return (
    <div className={"row if_wrap"}>
      {/* {ifmpage.page && ifmpage.redirectLink && <>
          {/* <iframe src={ifmpage.redirectLink} className={ifmpage.opacity ? "iframeWrap ifr_opacity":"iframeWrap"}></iframe> */}
      {/* <Iframe url={ifmpage.redirectLink} className={ifmpage.opacity ? "iframeWrap ifr_opacity":"iframeWrap"} /> 
        </> */}
      {ifmpage.page && ifmpage.redirectLink && (
        <React.Fragment>
          {console.log(ifmpage.page, ifmpage.redirectLink)}

          <iframe
            id="nocodemyframe"
            title="Diro nocode url"
            src={ifmpage.redirectLink}
            className={
              ifmpage.opacity ? "iframeWrap ifr_opacity" : "iframeWrap"
            }
            allow="clipboard-read *; clipboard-write *"
          ></iframe>
        </React.Fragment>
      )}
      <div className="App">
        {/* <h1>Hii</h1> */}
        {/* <Spinner /> */}
        <div className={"item"}>
          {/* {mobPupup === "Warning" || mobPupup === "Disable" ? (
            <div className="loader_wrapper warning_box warnIframe">
              <div className="warning_box">
                <p className="redirect_message">
                  Start this session from your desktop vs. mobile device for an
                  optimized user experience.
                </p>
                {mobPupup === "Warning" && (
                  <div style={{ textAlign: "right", width: "100%" }}>
                    <button className="skip_btn" onClick={redirect}>
                      Skip
                    </button>
                  </div>
                )}
              </div>
            </div>
          ) : ( */}
          <div className="loader_wrapper outerLoadIframe">
            {/* <Loader type="bubble-loop" bgColor={"#212529"} title={"Please wait"} color={'#212529'} height="60" size={50} /> */}
            <div className="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className="card-info text-center mb-3">
              <div className="card-info text-center">
                <h6 className="card-title w-75 mx-auto mb-0 lh-base ng-binding">
                  {" "}
                  Please wait{" "}
                </h6>
              </div>
            </div>
          </div>
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default IframePage;
